module.exports = __webpack_public_path__ + "assets/8dbe5d0304c4c3d952a5d02e49cfe74f.jpg";